import type { ReactNode } from 'react';
import styles from './Section.module.css';

interface SectionProps {
  badge: ReactNode;
  title: string;
  children: ReactNode;
}

export function Section({ badge, title, children }: SectionProps) {
  return (
    <section className={styles.section}>
      <h2 className={styles.title}>
        <i className={styles.badge}>{badge}</i>
        {title}
      </h2>
      {children}
    </section>
  );
}

export function SectionNote({ children }: { children: ReactNode }) {
  return <p className={styles.note}>{children}</p>;
}
